import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HitmakerMainPageComponent } from './component/hitmaker-main-page/hitmaker-main-page.component';
import { HitmakerMoviePageComponent } from './component/hitmaker-movie-page/hitmaker-movie-page.component';
import { CastingComponent } from './component/casting/casting.component';
import { StageUploadComponent } from './component/stage-upload/stage-upload.component';
import { AuthGuard } from 'src/app/core/authentication/auth.guard';
import { StageUpdateComponent } from './component/stage-update/stage-update.component';
import { PreProductionComponent } from './component/pre-production/pre-production.component';
import { FilmingComponent } from './component/filming/filming.component';
import { PostProductionComponent } from './component/post-production/post-production.component';
import { ReleaseComponent } from './component/release/release.component';

const routes: Routes = [
  {
    path: '',
    component:HitmakerMainPageComponent,
  
  },
  {
    path: ':id',
    component:HitmakerMoviePageComponent,
  
  },
  {
    path: ':id/stage/casting',
    component:CastingComponent,
    canActivate: [AuthGuard]

  },
  {
    path: ':id/stage/pre-production',
    component: PreProductionComponent,
    canActivate: [AuthGuard]

  },
  {
    path: ':id/stage/filming',
    component: FilmingComponent,
    canActivate: [AuthGuard]

  },
  {
    path: ':id/stage/post-production',
    component: PostProductionComponent,
    canActivate: [AuthGuard]

  },
  {
    path: ':id/stage/release',
    component: ReleaseComponent,
    canActivate: [AuthGuard]

  },
  {
    path: ':id/stage/:stage-name/upload',
    component:StageUploadComponent,
    canActivate: [AuthGuard]

  },
  {
    path: ':id/stage/:stage-name/update/:stage-id',
    component: StageUpdateComponent,
    canActivate: [AuthGuard]

  }
  

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HitmakerRoutingModule { }
